export enum GameState {
  FIRST_START,
  MAIN_MENU,
  CONFIG_GAME,
  INGAME,
  SCORESCREEN,
  EDITOR,
}

export enum ObjectAmounts {
  RAN_8,
  RAN_16,
  RAN_24,
}
